import { Grid } from '@material-ui/core'
import React, { Fragment, useState } from 'react'
import CardsQuantidades from './CardsQuantidades'
import CardsTempoReal from './CardsTempoReal'
import TableFilaSolicitacoes from './FilaSolicitacoes/TableFilaSolicitacoes'
import TableFilaSolicitacoesDocumentos from './FilaSolicitacoes/TableFilaSolicitacoesDocumentos'
import TableAnaliseAtual from './TableAnaliseAtual'
import TablePendendeAtual from './TablePendendeAtual'
import TablePendenteGestorAtual from './TablePendenteGestorAtual'

const PainelSolicitacoesTempoReal = props => {
  const [fila, setFila] = useState(0)
  const [filaAnaliseDocumentos, setFilaAnaliseDocumentos] = useState(0)
  const [analise, setAnalise] = useState(0)
  const [pendete, setPendente] = useState(0)
  const [pendeteGestor, setPendenteGestor] = useState(0)

  return (
    <Fragment>
      <Grid container spacing={2}>
        <CardsTempoReal {...props} />
        <CardsQuantidades
          {...props}
          quantidadeFila={fila}
          quantidadeFilaAnaliseDocumentos={filaAnaliseDocumentos}
          quantidadeAnalise={analise}
          quantidadePendete={pendete}
          quantidadePendeteGestor={pendeteGestor}
        />
        <TableFilaSolicitacoes {...props} setQuantidade={setFila} />
        <TableFilaSolicitacoesDocumentos
          {...props}
          setQuantidade={setFilaAnaliseDocumentos}
        />
        <TableAnaliseAtual {...props} setQuantidade={setAnalise} />
        <TablePendendeAtual {...props} setQuantidade={setPendente} />
        <TablePendenteGestorAtual
          {...props}
          setQuantidade={setPendenteGestor}
        />
      </Grid>
    </Fragment>
  )
}

export default React.memo(PainelSolicitacoesTempoReal)
